import { ModalFooter } from 'reactstrap';
import styled from 'styled-components';

export const StyledModalFooter = styled(ModalFooter)`
  padding: 1.5rem 0;
`;
